export const GET_NOTICES_LOADING = 'GET_NOTICES_LOADING'
export const GET_NOTICES_COMPLETE = 'GET_NOTICES_COMPLETE'
export const GET_NOTICES_ERROR = 'GET_NOTICES_ERROR'


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/notices/mutation-types.js
// module id = null
// module chunks = 